(function () {
  document.querySelectorAll('.pfs').forEach(function (root) {
    if (root.dataset.pfsInit === 'true') return;
    root.dataset.pfsInit = 'true';

    var textSource = root.querySelector('.pfs__source-text');
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('.pfs__source-media li'));
    var panelsHost = root.querySelector('[data-pfs-panels]');
    if (!textSource || !panelsHost || mediaItems.length === 0) return;

    var bullets = Array.prototype.slice.call(textSource.querySelectorAll('li'));
    if (bullets.length === 0) {
      // fall back to paragraphs / headings if the metafield isn't a bullet list
      bullets = Array.prototype.slice.call(textSource.querySelectorAll('p, h2, h3')).filter(function (n) {
        return n.textContent.trim().length > 0;
      });
    }
    if (bullets.length === 0) return;

    // Match each bullet to the gallery image whose alt text shares the most
    // feature keywords with it (e.g. a bullet mentioning "fingerprint" prefers
    // an image whose alt text also says "fingerprint"). To pair a specific
    // image to a specific feature, just add that keyword to the image's alt
    // text in Shopify Admin (Product > Media) — no code change needed. Falls
    // back to gallery order for any bullet with no keyword match, same as before.
    var STOPWORDS = ['the', 'and', 'for', 'with', 'via', 'your', 'you', 'this', 'that', 'from', 'into', 'without', 'app', 'lock', 'door'];
    function keywordsFrom(text) {
      return (text || '')
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .split(/\s+/)
        .filter(function (w) {
          return w.length > 2 && STOPWORDS.indexOf(w) === -1;
        });
    }
    var mediaKeywords = mediaItems.map(function (m) {
      return keywordsFrom(m.dataset.alt);
    });
    var usedMedia = {};
    function pickMedia(bulletText, fallbackIndex) {
      var bulletWords = keywordsFrom(bulletText);
      var bestIdx = -1;
      var bestScore = 0;
      mediaItems.forEach(function (m, idx) {
        if (usedMedia[idx]) return;
        var score = 0;
        mediaKeywords[idx].forEach(function (w) {
          if (bulletWords.indexOf(w) !== -1) score++;
        });
        if (score > bestScore) {
          bestScore = score;
          bestIdx = idx;
        }
      });
      var idx = bestIdx !== -1 ? bestIdx : fallbackIndex % mediaItems.length;
      var guard = 0;
      while (usedMedia[idx] && guard < mediaItems.length) {
        idx = (idx + 1) % mediaItems.length;
        guard++;
      }
      usedMedia[idx] = true;
      return mediaItems[idx];
    }

    var frag = document.createDocumentFragment();

    bullets.forEach(function (bullet, i) {
      var media = pickMedia(bullet.textContent, i);

      var panel = document.createElement('div');
      panel.className = 'pfs__panel' + (i % 2 === 1 ? ' pfs__panel--reverse' : '');

      var mediaWrap = document.createElement('div');
      mediaWrap.className = 'pfs__panel-media';
      var img = document.createElement('img');
      img.src = media.dataset.src;
      img.srcset = media.dataset.srcset || '';
      img.sizes = '(min-width: 750px) 50vw, 100vw';
      img.alt = media.dataset.alt || '';
      img.loading = 'lazy';
      img.width = media.dataset.width || 800;
      img.height = media.dataset.height || 600;
      mediaWrap.appendChild(img);

      var copy = document.createElement('div');
      copy.className = 'pfs__panel-copy';
      var index = document.createElement('p');
      index.className = 'pfs__panel-index';
      index.textContent = String(i + 1).padStart(2, '0');
      var text = document.createElement('p');
      text.className = 'pfs__panel-text';
      text.textContent = bullet.textContent.trim();
      copy.appendChild(index);
      copy.appendChild(text);

      panel.appendChild(mediaWrap);
      panel.appendChild(copy);
      frag.appendChild(panel);
    });

    panelsHost.appendChild(frag);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('pfs--visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
      );
      root.querySelectorAll('.pfs__panel').forEach(function (panel) {
        observer.observe(panel);
      });
    } else {
      root.querySelectorAll('.pfs__panel').forEach(function (panel) {
        panel.classList.add('pfs--visible');
      });
    }
  });
})();
